/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { motion } from 'framer-motion';
import { ReactComponent as Logo } from '../assets/logo.svg';
import {
  URL_NESTLE, URL_PRIVACY, URL_TERMS, URL_WORKPLACE,
} from '../utils/constants';

export default function Footer() {
  return (
    <motion.footer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className="fixed bottom-0 left-0 right-0 z-50 flex w-full flex-wrap items-center justify-center gap-x-6 gap-y-2 bg-gradient-to-r from-neutral-50 to-neutral-100 px-4 py-4 text-xs shadow-t-lg sm:text-sm md:gap-x-8 md:py-5"
    >
      <Logo className="h-7 w-auto text-slate-700 md:h-8" />
      <a
        target="_blank"
        href={URL_NESTLE}
        className="text-slate-600 transition-colors duration-300 hover:text-blue-600 hover:underline"
        rel="noopener noreferrer"
      >
        © {new Date().getFullYear()} Nestlé
      </a>
      <span className="hidden text-slate-400 md:inline">|</span>
      <a
        target="_blank"
        href={URL_PRIVACY}
        className="text-slate-600 transition-colors duration-300 hover:text-blue-600 hover:underline"
        rel="noopener noreferrer"
      >
        Privacy
      </a>
      <span className="hidden text-slate-400 md:inline">|</span>
      <a
        target="_blank"
        href={URL_TERMS}
        className="text-slate-600 transition-colors duration-300 hover:text-blue-600 hover:underline"
        rel="noopener noreferrer"
      >
        Terms of use
      </a>
      <span className="hidden text-slate-400 md:inline">|</span>
      <a
        target="_blank"
        href={URL_WORKPLACE}
        className="text-slate-600 transition-colors duration-300 hover:text-blue-600 hover:underline"
        rel="noopener noreferrer"
      >
        Workplace
      </a>
    </motion.footer>
  );
}
